import {toggleClass} from './dom';
import visibility,{topAnchor,centerAnchor,getNavbarOffset} from './visibility';
import {dispatch} from './events';

export const defaultIsReady = ()=>{
  return document.documentElement.classList.contains('no-intro') && !document.documentElement.classList.contains('is-changing');
}

export default function sections({
  selector = '.page-section',
  smooth=10,
  navbarOffset = getNavbarOffset(),
  endClass = 'page-end',
  isReady = defaultIsReady,
  onUpdate,
  ...settings
} = {}){
  let current = 0;
  let ready = !isReady;

  return visibility({
    ...settings,
    selector,
    smooth,
    navbarOffset,
    anchor:topAnchor,
    onCreate(elements){
      dispatch(document,"sections:create",{elements,currentIndex:current});
    },
    onDestroy(){
      dispatch(document,"sections:destroy");
    },
    onUpdate(elements){
      const previous = current;
      current = 0;
      for(let i=0;i<elements.length;++i){
        const section = elements[i];
        const wasScrolledPast = section.getBoundingClientRect().top < centerAnchor();
        if(wasScrolledPast){
          current = i;
        }else{
          break;
        }
      }
      const {documentElement:html} = document;
      html.style.setProperty('--current-section',current);
      onUpdate&&onUpdate(current,previous);
      if(previous !== current){
        dispatch(document,"sections:change",{
          currentIndex:current,
          previousIndex:previous,
          elements
        });
      }

      if(isReady && !ready && isReady()) {
        ready = true;
      }
    },
    onUpdateElement(section,index,offset){
      if(!ready) return;

      toggleClass(section,'is-current',index===current);

      toggleClass(section,'is-active',index<=current);

      if(index===current)
        toggleClass(section,'was-current',true);

      if(index === sections.length - 1)
        toggleClass(html,endClass,offset < .5);
    },
    onOffsetChange(section,offset){
      dispatch(section,'sections:offsetchange',{offset});
    }
  });
}